import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import getDateWithTimeZone from 'helpers/getDateWithTimeZone';
import classes from './DocumentsResearch.module.scss';

export default function ReportFooter() {
  const { t } = useTranslation();
  const userData = useAppSelector((state) => state.userData.userData);

  return (
    <div className={classes.info_footer}>
      <div className={classes.info_footer_title}>
        <div className={classes.footer_label}>
          {t('Report.info.reportInitiator')}:
        </div>
        <div className={classes.footer_value}>
          {userData ? `${userData.first_name} ${userData.last_name}` : '-'}
          {userData?.email && (
            <div className={classes.footer_email}>{userData.email}</div>
          )}
        </div>
      </div>
      <div className={classes.info_footer_date}>
        <div className={classes.footer_label}>
          {t('Report.info.reportGenerationDateTime')}:
        </div>
        <div className={classes.footer_value}>
          {userData
            ? getDateWithTimeZone(
                new Date().toISOString(),
                userData.date_format
              )
            : new Date().toLocaleString()}
        </div>
      </div>
    </div>
  );
}
